export const getEventHandlers = ({ userVehicleId, handleClick, keyOptions, masterVehicle }) => {
  const handlers = {}

  handlers.onClick = (e) => {
    handleClick && handleClick(userVehicleId, masterVehicle)
  }

  if (keyOptions) {
    handlers.onKeyDown = ({ keyCode }) => {
      const handler = keyOptions[keyCode]
      handler && handler(userVehicleId, masterVehicle)
    }
  }

  handlers.onBlur = (e) => {
    e.preventDefault()
  }

  return handlers
}
